<script setup lang="ts">
const store = useBigHeroBannerStore();
const slides = computed(() => {
  if (store.previousSlide) {
    return [
      {
        index: store.previousSlideIndex,
        banner: store.previousSlide,
      },
      {
        index: store.currentSlideIndex,
        banner: store.currentSlide,
      },
    ];
  } else {
    return [
      {
        index: store.currentSlideIndex,
        banner: store.currentSlide,
      },
    ];
  }
});
</script>

<template>
  <section>
    <BigHeroBannerSliderContainer>
      <BigHeroBannerCurrent
        v-for="(k, i) of slides"
        :key="i"
        :index="k.index"
        :data="k.banner"
      />
      <BigHeroBannerScreenReader v-if="store.status === LoadStatus.Ready" />
      <BigHeroBannerControls
        v-if="store.status === LoadStatus.Ready && store.banners.length > 1"
      />
    </BigHeroBannerSliderContainer>
  </section>
</template>

<style scoped lang="postcss">
.empty-container {
  @apply bg-transparent text-black;
}
</style>
